import { useEffect } from 'react';

export const useSSOTokenHandler = (loginWithSSORequest, addNotification, t) => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');
    const isPasswordFlow = window.location.pathname.includes('/passwords/');

    if (isPasswordFlow) {
      return;
    }

    if (token === '') {
      window.history.pushState(null, null, window.location.pathname);

      addNotification({
        type: 'warning',
        message: t('dash.signIn.login_method_required_message'),
      });
    } else if (token) {
      loginWithSSORequest({ session: { token } });
      window.history.pushState(null, null, window.location.pathname);
    }
  }, [loginWithSSORequest, addNotification, t]);
};
